import Top5InsectsPanel from './Top5InsectsPanel';

export default Top5InsectsPanel;
